module.exports = __webpack_public_path__ + "img/drag_arrow_icon.8616a41e.svg";